import FileSaver from 'file-saver';

angular.module('am4').factory('downloadService', function() {
    return function(name, contents) {
        var blob = new Blob([contents], {
            type: 'text/csv;charset=utf-8'
        });

        // third argument true disables the utf-8 BOM
        FileSaver.saveAs(blob, name, true);
    };
});



// WEBPACK FOOTER //
// ./src/app/services/download.js